import React from 'react';

const LinkifiedText = ({ text, isUser }) => {
    // Retorna nulo se o texto não for fornecido para evitar erros
    if (!text) {
        return null;
    }

    // Expressão regular para encontrar URLs em um texto
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return (
        <p>
            {parts.map((part, index) => {
                // Se a parte do texto corresponde à URL, cria um link <a>
                if (part.match(urlRegex)) {
                    return (
                        <a
                            key={index}
                            href={part}
                            target="_blank"
                            rel="noopener noreferrer"
                            // Aplica estilos diferentes se o link é do usuário ou do contato
                            className={isUser ? "text-white underline hover:text-blue-200" : "text-blue-600 underline hover:text-blue-800"}
                            // Impede que o clique no link acione o clique na bolha da mensagem
                            onClick={(e) => e.stopPropagation()}
                        >
                            {part}
                        </a>
                    );
                }
                // Se não for uma URL, apenas retorna o texto
                return part;
            })}
        </p>
    );
};

export default LinkifiedText;